<template>
	<div style="width:90%">
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
					<el-form-item label="用户ID" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.userId" placeholder="请输入用户ID">
						</el-input>
					</el-form-item>
                    <el-form-item label="用户账号" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.username" placeholder="请输入账号"></el-input>
					</el-form-item>
					<el-form-item label="手机号" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.phone" placeholder="请输入手机号"></el-input>
					</el-form-item>

                    <el-form-item label="标题" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.title" placeholder="请输入标题"></el-input>
					</el-form-item>
					<el-form-item label="描述" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.content" placeholder="请输入描述"></el-input>
					</el-form-item>

                    <el-form-item label="状态" class='tiny '>
						<el-select v-model="searchInfo.status" placeholder="请选择" clear>
							<el-option key="9" label="全部" value="">全部</el-option>
                            <el-option key="0" label="待审核" value="0"></el-option>
							<el-option key="1" label="正常" value="1"></el-option>
							<el-option key="2" label="封禁" value="2"></el-option>
						</el-select>
					</el-form-item>
                    <el-form-item label="作品类型" class='tiny '>
						<el-select v-model="searchInfo.type" placeholder="请选择" clear>
							<el-option key="9" label="全部" value="">全部</el-option>
							<el-option key="1" label="公开" value="1"></el-option>
							<el-option key="2" label="私密" value="2"></el-option>
						</el-select>
					</el-form-item>

					<!-- <el-form-item label="变动时间">
						<div class="block">
							<el-date-picker v-model="timer" value-format="yyyy-MM-dd HH:mm:ss"
								type="datetimerange" start-placeholder="开始日期" end-placeholder="结束日期"
								:default-time="['00:00:00', '23:59:59']">
							</el-date-picker>
						</div>
					</el-form-item> -->

					<el-form-item>
						<template>
							<el-button type="primary" @click="search">查询</el-button>
							<el-button @click="empty">清空</el-button>
							<!-- <el-button type="primary" @click="downloadFile"> 导出 </el-button>
							</el-button> -->
						</template>
					</el-form-item>
				</el-form>
			</header>
		</div>
		<el-table :data="withdrawal.list" stripe style="width: 100%;" :header-cell-style="headClass" v-loading="loading"
			element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" >
            <el-table-column type="expand">
				<template slot-scope="props">
					<el-form label-position="left" inline class="demo-table-expand" label-width="150px">
						<el-form-item label="是否是长视频">
							<span v-if="props.row.isLongVideo">是</span>
							<span v-else>否</span>
						</el-form-item>
                        <el-form-item label="视频时长">
							<span>{{ props.row.videoDuration }}</span>
						</el-form-item>
                        <el-form-item label="视频大小(KB)">
							<span>{{ props.row.size }}</span>
						</el-form-item>
                        <el-form-item label="标签">
							<span>{{ props.row.label }}</span>
						</el-form-item>
					</el-form>
				</template>
            </el-table-column>
			<el-table-column prop="" label="发布用户" align="center" :show-overflow-tooltip="true" min-width="150">
                <template slot-scope="scope">
					<span >{{scope.row.userId}}</span>
					<span v-if="scope.row.username">~ {{scope.row.username}}</span>
					<span v-if="scope.row.phone">~ {{scope.row.phone}}</span>
				</template>
			</el-table-column>
            <!-- <el-table-column prop="imgUrl" label="封面图" align="center" :show-overflow-tooltip="true" >
                <template slot-scope="scope">
                    <el-button size="small" type="text" @click="showContent(scope.row)">点击查看</el-button>
                </template>
			</el-table-column> -->

			<el-table-column prop="title" label="标题" align="center" :show-overflow-tooltip="true" >
			</el-table-column>
            <el-table-column prop="content" label="描述" align="center" :show-overflow-tooltip="true">
			</el-table-column>
            <el-table-column prop="videoUrl" label="视频详情" align="center" :show-overflow-tooltip="true" >
                <template slot-scope="scope">
                    <el-button size="small" type="text" @click="showContent(scope.row)">点击查看</el-button>
                </template>
			</el-table-column>
            <el-table-column prop="type" label="作品类型" align="center" :show-overflow-tooltip="true" >
                 <template slot-scope="scope">
					<div v-if="scope.row.type==1">公开</div>
					<div v-if="scope.row.type==2">私密</div>
				</template>
			</el-table-column>
             <el-table-column prop="goodsId" label="商品" align="center" :show-overflow-tooltip="true" >
                 <template slot-scope="scope">
                    <el-button  v-if="scope.row.goodsId" size="small" type="text" 
                    @click="goodsDetail(scope.row.goodsId)">点击查看</el-button>
                    <span v-else>未带商品</span>
                </template>
			</el-table-column>
            <el-table-column prop="" label="状态" align="center" :show-overflow-tooltip="true" >
                <template slot-scope="scope">
                    <div v-if="scope.row.status==0" style="color:#E6A23C">待审核</div>
					<div v-if="scope.row.status==1" style="color:#67C23A;">正常</div>
					<div v-if="scope.row.status==2" style="color:#F56C6C;">封禁</div>
				</template>
			</el-table-column>
            
			<!-- <el-table-column prop="videoDuration" label="时长" align="center" :show-overflow-tooltip="true" >
			</el-table-column> -->
            <!-- <el-table-column prop="isLongVideo" label="是否长视频" align="center" :show-overflow-tooltip="true" >
			</el-table-column> -->
            <el-table-column prop="views" label="浏览量" align="center" :show-overflow-tooltip="true" >
			</el-table-column>
            <el-table-column prop="likes" label="点赞量" align="center" :show-overflow-tooltip="true" >
			</el-table-column>
            <el-table-column prop="comments" label="评论数" align="center" :show-overflow-tooltip="true" >
			</el-table-column>
            <el-table-column prop="shares" label="分享数" align="center" :show-overflow-tooltip="true" >
			</el-table-column>
            <!-- <el-table-column prop="size" label="视频大小(KB)" align="center" :show-overflow-tooltip="true" >
			</el-table-column> -->
            <el-table-column prop="collections" label="收藏数" align="center" :show-overflow-tooltip="true" >
			</el-table-column>
            
            <!-- <el-table-column prop="label" label="标签" align="center" :show-overflow-tooltip="true" >
			</el-table-column> -->
           
            <!-- <el-table-column prop="orderIndex" label="排序" align="center" :show-overflow-tooltip="true" >
			</el-table-column> -->

			<el-table-column prop="createTime" label="创建时间" align="center" :show-overflow-tooltip="true" >
			</el-table-column>
            <el-table-column  label="操作"  fixed="right" align="center">
				<template slot-scope="scope">
					<el-button v-if="scope.row.status==1" size="small" type="text" 
                    @click="queryIntegralWithdrawal(scope.row, 2, '封禁')">封禁</el-button>

					<el-button  size="small" type="text" v-if="scope.row.status==2" 
                    @click="queryIntegralWithdrawal(scope.row, 1, '解禁')">解禁</el-button>
				</template>
            </el-table-column>
			
		</el-table>
		<el-pagination style="margin: 20px;" background :current-page="withdrawal.pageNum" @current-change="pageChange"
			layout="total, sizes, prev, pager, next, jumper" :total="withdrawal.total" @size-change="handleSizeChange">
		</el-pagination>

		
		<!-- 审核 -->
		<el-dialog style="float:rigin" :title="title+'视频'" :visible.sync="queryDialogVisible" width="50%" center
			:close-on-click-modal="false">
            <div>
                <h2>{{ auditInfo.title }}</h2>
                <div >{{ auditInfo.content }}</div>
                <div style="height:20px;"></div>
                <div style="width:100%;">
                    <video controls :src="auditInfo.videoUrl"
                    :poster="auditInfo.imgUrl" loop 
                    style="width:100%;height:auto;"></video>
                </div>
            </div>
            <div style="height:20px;"></div>
            <div>
                <el-form >
                    <el-form-item label="封禁理由:"  v-if="typeNum==2">
						<el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="reason">
                        </el-input>
					</el-form-item>
					<el-form-item label="封禁理由:"  v-if="typeNum==1">
						{{ auditInfo.refuseReason }}
					</el-form-item>
                </el-form>
            </div>
			<div style="text-align: center;">
                <el-button  @click="queryDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="confirm" :loading="confirmLoading">确认{{title}}</el-button>
			</div>
		</el-dialog>
		
        <el-dialog title="查看详情" :visible.sync="showContentDialog" width="800px" :close-on-click-modal="false">
            <div>
                <!-- <div style="font-size: 16px;">{{ showContentInfo.title }}</div> -->
                <h2>{{ showContentInfo.title }}</h2>
                <div >{{ showContentInfo.content }}</div>
                <div style="height:20px;"></div>
                <div style="width:100%;">
                    <video controls :src="showContentInfo.videoUrl"
                    :poster="showContentInfo.imgUrl" loop 
                    style="width:100%;height:auto;"></video>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="showContentDialog = false">关 闭</el-button>
			</span>
		</el-dialog>  

        <!-- 查看 -->
		<el-dialog title="查看商品" :visible.sync="goodDetailDialog" width="800px" :close-on-click-modal="false">
            <div>
                <el-form >
                    <div>商品图片:</div>
                    <el-carousel trigger="click" height="450px">
                        <el-carousel-item v-for="item in goodInfo.images" :key="item" >
                            <div style="display: flex;justify-content: center;">
                                <img :src="item" style="width:400px;height:400px;">
                            </div>
                        </el-carousel-item>
                    </el-carousel>
                     <el-form-item label="商品名称:" class="redItem" >
						{{goodInfo.goodsName}}
					</el-form-item>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="价格:" class="redItem" style="width: 50%;">
							<span >{{goodInfo.price}}</span>
						</el-form-item>
					
						<el-form-item label="销量:" class="redItem" style="width: 50%;">
							{{goodInfo.salesSum}}
						</el-form-item>
					</div>
                    <div>
                        <div>商品详情:</div>
                        <div style="height:10px;"></div>
						<div class="htmlImg">
							<div v-html="goodInfo.detail"></div>
						</div>
                        
                    </div>
                </el-form>
            </div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="goodDetailDialog = false">关 闭</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	
	export default {
		data() {
			return {
                showContentDialog:false,
                showContentInfo: {},
				searchInfo: {
                    status: '',
                    type: '',
				},
				loading: false,
				queryDialogVisible:false,
				withdrawal: {},
				page: {
					pageNum: 1,
					pageSize: 10
				},
				typeNum:'',
				title:'',
                
                timer: [],

                goodInfo: {},
                goodDetailDialog: false,
                reason: '',
                auditInfo: {},
                confirmLoading: false,
			}
		},
		methods: {
            goodsDetail(id){
                this.$api.storeGoodsFindById(id).then((res) => {
                    if (res.state == 'success') {
                        this.goodInfo = res.data;
                        let imagesArray = res.data.images.split(",");
                        this.goodInfo.images = imagesArray
                        this.goodDetailDialog = true
                    }else{
                        this.$message.error(res.message);
                    }
                })     
            },
			showContent(content) {
				this.showContentInfo = content
				this.showContentDialog = true
			},
			
			// 查询
			search() {
				this.page.pageNum = 1;
				this.getVideoList()
			},
			// 清空
			empty() {
                this.timer = []
				this.searchInfo = {}
			},
			//导出
			downloadFile() {

			},
			// 通过
			confirm(){
				if(this.typeNum==1){ //解禁
					this.confirmLoading = true
					this.$api.auditVideoInfo({
						id: this.auditInfo.id,
						status: 1
					}).then(res=>{
						if(res.state == 'success'){
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.queryDialogVisible = false
							this.getVideoList()
						}else{
							this.$message.error(res.message);
						}
						this.confirmLoading = false
					})
				}
				if(this.typeNum==2){ //封禁
					if(this.reason){}else{
						this.$message.error('审核理由不可为空');
						return
					}
					this.confirmLoading = true
					this.$api.auditVideoInfo({
						id: this.auditInfo.id,
						refuseReason: this.reason,
						status: 2
					}).then(res=>{
						if(res.state == 'success'){
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.queryDialogVisible = false
							this.getVideoList()
						}else{
							this.$message.error(res.message);
						}
						this.confirmLoading = false
					})
				}
			},
			queryIntegralWithdrawal(item,type,title) {
                this.auditInfo = item;
				this.title = title
				// console.log(title);
				this.typeNum = type
				this.reason = '';
				this.queryDialogVisible=true
				
			},

			pageChange(data) {
				this.page.pageNum = data
				this.getVideoList()
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.getVideoList()
			},
			//编辑弹框
			headClass() {
				return 'text-align:center;background:#E6E9F0;color: rgb(31, 46, 77);height:56px'
			},
			getVideoList() {
				this.loading = true
				let data = {
					pageNum: this.page.pageNum,
					pageSize: this.page.pageSize,
					// startTime: this.timer ? this.timer[0] : "",
					// endTime: this.timer ? this.timer[1] : "",
					...this.searchInfo
                }
                // this.$encrypt(data)
				this.$api.getShortVideoList(data).then(res => {
					// res = JSON.parse(this.$decrypt(res.data))
					if (res.state == 'success') {
						// console.log('数据---',res);
						this.withdrawal = res.data
						this.loading = false
					}
				})
			}
		},
		created() {
			this.getVideoList()
		}
	}
</script>

<style scoped lang="less">
	.demo-table-expand {
		font-size: 0;
		margin-left: 30px;
	}

	.demo-table-expand label {
		width: 100px;
		color: #99a9bf;
	}

	.demo-table-expand .el-form-item {
		margin-right: 0;
		margin-bottom: 0;
		width: 50%;
	}

	.lpc-quill img {
		width: 100px;
		height: 120px;
	}

	.lpc-quill-en img {
		width: 100px;
		height: 120px;
	}

	/deep/.el-input__inner {
		color: black !important;
	}

	/deep/.el-textarea__inner {
		color: black !important;
    }
    
    .redItem{
        margin-bottom: 10px;
	}
	
	.htmlImg{
		height: 300px;
		overflow-y: scroll;
		::v-deep img{
			width: 100%;
			height: auto;
		}
	}
</style>